import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Expandable = ({ isOpen, children }) => {
  const classes = cx('Expandable', { open: isOpen });
  return <div className={classes}>{children}</div>;
};

Expandable.displayName = 'Expandable';

Expandable.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default Expandable;
